import { useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { ENV_DEFAULT_BANK_READER } from "../../../../../config/envVars";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../../utils/hooks/useActionCallback";
import { findParticipantOnboardingDetailsByRole } from "../../../../../utils/participants";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../../../shared/config";
import { BankReaderName } from "../../BankReader/components/BankReaderFactory/types/BankReaderName";

export const useCashInCashOutMethod = () => {
  const {
    state: { loan, participant, borrowerBankReader },
    dispatch,
  } = useContext(ProcessContext);

  const navigateToBorrowerBankReader = () =>
    dispatch({ type: "SET_FLOW_ITEM_PREVIOUS" });

  const getBorrowerBankReaderOrSkipModule = () => {
    if (ENV_DEFAULT_BANK_READER === BankReaderName.EUROBITS) {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      return;
    }
    try {
      const borrowerBankReaderId =
        getBorrowerBankReaderIdFromOnboardingDetails();
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: true },
      });
      dispatch({
        type: "REQUEST_GET_BORROWER_BANK_READER_BY_ID",
        payload: borrowerBankReaderId,
      });
    } catch (err) {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      return;
    }
  };

  const getBorrowerBankReaderIdFromOnboardingDetails = () => {
    const onboardingDetails = findParticipantOnboardingDetailsByRole(
      loan,
      ONBOARDING_PARTICIPANT_ROLES.BORROWER
    );
    if (!onboardingDetails?.borrower_bank_reader_id) {
      throw new Error(
        "OnboardingDetails must include a valid borrower_bank_reader_id"
      );
    }
    return onboardingDetails.borrower_bank_reader_id;
  };

  useActionCallback("REQUEST_GET_BORROWER_BANK_READER_BY_ID_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
  });

  useActionCallback("REQUEST_GET_BORROWER_BANK_READER_BY_ID_REJECTED", () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
  });

  const postAddCashInCashOutMethod = (accountNumber) => {
    const cashInCashOutMethodId = uuidv4();
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    dispatch({
      type: "REQUEST_POST_ADD_CASH_IN_CASH_OUT_METHOD_TINK",
      payload: {
        loan_id: loan.id,
        borrower_id: participant.participantId,
        cash_in_cash_out_method_id: cashInCashOutMethodId,
        borrower_bank_reader_id: borrowerBankReader.id,
        account_number: accountNumber,
      },
    });
  };

  useActionCallback(
    "REQUEST_POST_ADD_CASH_IN_CASH_OUT_METHOD_TINK_FULFILLED",
    () => {
      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      dispatch({
        type: "SET_FLOW_MESSAGE",
        payload: { id: FLOW_MESSAGES.SEND_OK.id },
      });
    }
  );

  useActionCallback(
    "REQUEST_POST_ADD_CASH_IN_CASH_OUT_METHOD_TINK_REJECTED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );

  return {
    borrowerBankReader,
    getBorrowerBankReaderOrSkipModule,
    postAddCashInCashOutMethod,
    navigateToBorrowerBankReader,
  };
};
